export default {
  menu: 'Taxes',
  title: 'Taxes',

  general: {
    types: {
      vat: 'Vat',
      corporate: 'Corporate'
    },

    labels: {
      all: 'All',
      type: 'Type',
      paymentType: 'Payment type',
      date: 'Date of payment',
      from: 'From',
      to: 'To',
      user: 'Pay to',
      payer: 'Payer',
      price: 'Amount',
      description: 'Description',
      transactionsReferenceId: 'Tracking number',
      maxPayment: 'Maximum payable',
      dynamicBalance: 'credit {balance}',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        to: 'To',
        from: 'From',
        payer: 'Payer',
        type: 'Type',
        date: 'Date',
        docNumber: 'Document number'
      }
    },

    notifications: {
      invalidType: 'Type not selected',
      invalidPrice: 'Amount is not valid',
      invalidPayer: 'Payer not selected',
      invalidPaymentType: 'Payment type not specified',
      invalidDescription: 'Payment Description has not been entered',
      price: 'The entered amount is more than the maximum amount that can be paid!',
      lowBalance: 'The balance of the bank or fund is not enough!',
      lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
      incorrect_reference_id: 'reference id is not correct',

      insert: {
        success: 'Tax created successfully',
        error: 'Creating a tax with an error'
      },
      delete: {
        success: 'Tax information successfully deleted',
        error: 'Deleting tax information failed'
      },
      restore: {
        success: 'Tax information successfully restored',
        error: 'Restore the tax information was accompanied by an error'
      },
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The payment date is not entered correctly!',
      future: 'It is not possible to register a payment for the future'
    }
  },

  insert: {
    title: 'New Tax',

    suggests: {
      description: 'Received from {user} for {subject}'
    }
  },

  list: {
    title: 'Taxes'
  },

  trash: {
    title: 'Removed Taxes List'
  },

  document: {
    title: 'Tax',
    dynamicTitle: 'Tax number {docNumber}',

    confirmations: {
      delete: {
        title: 'Confirm Delete Tax',
        body: 'Are you sure you want to delete this tax completely?'
      }
    },

    labels: {
      from: 'From',
      to: 'To',
      payer: 'Payer / payers',
      destinations: 'Recipient / recipients',
      details: 'Other information',
      creator: 'creator',
      date: 'Registration date',
      description: 'Description'
    }
  },

  logs: {
    title: 'Tax logs'
  }
}
